import React from "react";
import Activites from "../components/ActivitySection";
import HeroActivity from "../components/ActivitySection/Hero/HeroActivity";

const Activity = () => {
  return (
    <>
      <Activites />
      <HeroActivity />
    </>
  );
};

export default Activity;
